<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Media costs & media coverage
            </v-row>
            <!--table head-->
            <v-divider />
            <v-row class="subtitle-2" no-gutters>
                <v-col class="tabCell text-left">Media</v-col>
                <v-col v-for="(item, i) in headers" :key="i" class="tabCell" :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <div v-if="media?.length">
                <!--media-costs row-->
                <div v-for="item in media" :key="item.id">
                    <v-row no-gutters>
                        <v-col class="tabCell text-left">Media costs</v-col>
                        <v-col class="tabCell text-center">{{ item.smm_cost }}</v-col>
                        <v-col class="tabCell text-center">{{ item.content_ads_cost }}</v-col>
                        <v-col class="tabCell text-center">{{ item.bloggers_influencers_cost }}</v-col>
                        <v-col class="tabCell text-center">{{ item.banner_ads_cost }}</v-col>
                        <v-col class="tabCell text-center">{{ item.postal_cost }}</v-col>
                        <v-col class="tabCell text-center">{{ formatNumber(item.outdoor_advertising_cost) }}</v-col>
                        <v-col class="tabCell text-center">{{ formatNumber(item.autoradio_podcasts_cost) }}</v-col>
                        <v-col class="tabCell text-center">{{ formatNumber(item.tv_cost) }}</v-col>
                        <v-col class="tabCell text-right">
                            <edit-media :media="item" />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col class="tabCell text-left">Media coverage</v-col>
                        <v-col class="tabCell text-center">{{ item.smm_coverage }}</v-col>
                        <v-col class="tabCell text-center">{{ item.content_ads_coverage }}</v-col>
                        <v-col class="tabCell text-center">{{ item.bloggers_influencers_coverage }}</v-col>
                        <v-col class="tabCell text-center">{{ item.banner_ads_coverage }}</v-col>
                        <v-col class="tabCell text-center">{{ item.postal_coverage }}</v-col>
                        <v-col class="tabCell text-center">{{ item.outdoor_advertising_coverage }}</v-col>
                        <v-col class="tabCell text-center">{{ item.autoradio_podcasts_coverage }}</v-col>
                        <v-col class="tabCell text-center">{{ item.tv_coverage }}</v-col>
                        <v-col class="tabCell text-right">
                            <delete-media :media="item" />
                        </v-col>
                    </v-row>
                </div>
            </div>
            <v-row v-else class="mt-8 px-4" justify="center">
                You don't have media yet!
            </v-row>

        </div>
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue'
import { localeNumber } from '../../../functions/common';
import DeleteMedia from '../../../components/admin/media/DeleteMedia.vue';
import EditMedia from '../../../components/admin/media/editMedia.vue';

export default {
    name: 'Media',
    data() {
        return {
            headers: [
                { title: 'SMM', style: 'text-center' },
                { title: 'Content Ads', style: 'text-center' },
                { title: 'Bloggers & influencers', style: 'text-center' },
                { title: 'Banner ads', style: 'text-center' },
                { title: 'Postal', style: 'text-center' },
                { title: 'Outdoor advertising', style: 'text-center' },
                { title: 'Autoradio podcasts', style: 'text-center' },
                { title: 'TV', style: 'text-center' },
                { title: 'Action', style: 'text-right' },
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        locale() {
            return this.$store.getters.locale;
        },
        media() {
            return this.$store.getters.media;
        },
       
    },
    methods: {
        formatNumber(number) {
            return localeNumber(number, this.locale)
        }
    },
    components: {
        Loader, DeleteMedia, EditMedia
    }
}
</script>